import {useInfiniteAddresses} from "@twigsby/client-data";
import {
    ComboBoxControl,
    FlexGap, FormWrapperMinimum,
    SelectItemType,
    StackHorizontal
} from "@twigsby/frontend-framework";
import {Controller, useFormContext} from "@twigsby/frontend-framework/lib/ReactHookForm";
import React from "react";
import {IncludeExclude} from "../Components/IncludeExclude";

type RecipientConditionType = {
    name: string;
    defaultValue: any;
    defaultIncludesValue: boolean;
    changeCallback: (value: any) => void;
}

const RecipientCondition = (props: RecipientConditionType) => {
    const { control, getValues, getFieldState} = useFormContext();

    const { data, status } = useInfiniteAddresses();

    const AddressOptions : Array<SelectItemType> = data ? data.pages.map((page) => page?.data && page.data.filter((address, index: number) =>
        address ? { 'label': address.label, 'value': address.value } : null
    ))[0] : [];

    return (
        <StackHorizontal gap={FlexGap.ExtraSmall}>
            <IncludeExclude name={`${props.name}.includes`} defaultValue={props.defaultIncludesValue} />

            <Controller
                control={control}
                name={`${props.name}.values`}
                defaultValue={props.defaultValue}
                rules={{ required: true, validate: (e) => e.length > 0 ? "Recipient is required" : true }}
                render={({ field, fieldState }) =>
                    <FormWrapperMinimum
                        invalid={getFieldState(`${props.name}.values`).invalid}
                        validationMessage={getFieldState(`${props.name}.values`).error?.message}
                    >
                        <ComboBoxControl
                            data={AddressOptions}
                            defaultValues={field.value}
                            forwardValuesCallback={(val) => {
                                field.onChange(val)
                            }}
                            name={field.name}
                            placeholder={'Select Recipient...'}
                            loading={status === 'loading'}
                            disabled={status === 'error'}
                            valueType={'number'}
                        />
                    </FormWrapperMinimum>
                }
            />
        </StackHorizontal>
    )
}

export { RecipientCondition }
